export const probationNotificationStorageKey: string = 'probationNotificationShowAt';
export const probationNotificationMessageKey: string = 'probation';
